import { Injectable } from '@angular/core';
import { TuiDay, TuiTime, TuiValueTransformer } from '@taiga-ui/cdk';

@Injectable()
export class DateTimeTransformer implements TuiValueTransformer<[TuiDay | null, TuiTime | null] | null, Date | null> {
  fromControlValue(controlValue: Date | null): [TuiDay | null, TuiTime | null] | null {
    return controlValue ? [TuiDay.fromLocalNativeDate(controlValue), TuiTime.fromLocalNativeDate(controlValue)] : null;
  }

  toControlValue(value: [TuiDay | null, TuiTime | null] | null): Date | null {
    if (!value) {
      return null;
    }

    const [day, time] = value;

    if (!day) {
      return null;
    }

    const date = day.toLocalNativeDate();
    const milliseconds = time?.toAbsoluteMilliseconds() || 0;

    return new Date(date.getTime() + milliseconds);
  }
}
